export default __webpack_public_path__ + "static/media/gold.5affe7e3.jpg";